export const SEARCH_VIEW = `import React from 'react';

interface searchViewProps {
eventData: any;
userData: any;
pluginData: any;
pluginComponents: any
}

export default function SearchView({ pluginComponents }: searchViewProps) {
    const {RequestAccessButton} = pluginComponents
    const [openDoorConfig, setOpenDoorConfig] = React.useState({
        experimentName: "My experiment",
        experimentTitle: "Open door experiment title",
        experimentDescription: "This is my description",
        experimentPrice: 40,
        experimentDiscountedPrice: 20,
        experimentCTAText: "Request early access",
    })
    return (

    <div className="video-preview p-4 bg-transparent">
        <div className="relative">
          <div className="flex items-center gap-2">
            
            <div>
              <div className="text-white/50 text-base">{openDoorConfig.experimentTitle}</div>
            </div>
            
          </div>
          
          <div className="text-white text-base mt-4 text-left">
            {openDoorConfig.experimentDescription}
          </div>
          <hr className="w-full border-white/30 my-4" />

          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="text-white text-base flex items-center">
                <span className="line-through text-gray-400 mr-2">
                  $ {openDoorConfig.experimentPrice}/invite
                </span>
                <span className="text-white font-medium">$ {openDoorConfig.experimentDiscountedPrice}/invite</span>
                <span className="ml-2 bg-white/10 text-white text-[12px] px-1 rounded">
                  {Math.round((openDoorConfig.experimentPrice - openDoorConfig.experimentDiscountedPrice)*100/openDoorConfig.experimentPrice)}% OFF
                </span>
              </div>
            </div>
            <RequestAccessButton experimentName={openDoorConfig.experimentName}>
               {openDoorConfig.experimentCTAText}</RequestAccessButton>

          </div>
        </div>
      </div>
    );
}`
